import { installIgnoredPromiseRejectionHandler } from './utils/ignoredPromiseRejections';

installIgnoredPromiseRejectionHandler();
